import { vouchersCommodityIds } from '@/api/order.js';

const state = {
  alipayCommodityIds: [],
  alipayAccessCode: '',
};

const mutations = {
  SET_ALIPAY_COMMODITY_IDS(state, list = []) {
    state.alipayCommodityIds = list;
  },
  SET_ALIPAY_ACCESS_CODE(state, alipayAccessCode = '') {
    state.alipayAccessCode = alipayAccessCode;
  },
};

const actions = {
  async listVouchersCommodityIds({ commit }) {
    const result = await vouchersCommodityIds();
    if (result.success && result.data?.length > 0) {
      const alipayCommodityIds = result.data;
      commit('SET_ALIPAY_COMMODITY_IDS', alipayCommodityIds);
    }
  },
  // 支付宝小程序用来获取用户授权查询用户支付宝商家券的
  getAlipayAccessCode({ commit }) {
    return new Promise((resolve, reject) => {




















    });
  },
};

export default {
  state,
  mutations,
  actions,
};
